module.exports = "https://www.gc-qa.gnp.com.mx/788ebdf1f5324f0eca424f6cbf08a332.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-previous.svg
// module id = 8060
// module chunks = 0